module.exports = __webpack_public_path__ + "img/img_residencial5.713f39e8.png";